import React from 'react';
import { Box } from '@drone-js/core';
import { BadgeService } from 'component/common/Badge/BadgeService';
import { connect } from 'react-redux';
import BadgeWithTooltip from 'component/common/Badge/BadgeWithTooltip';
import { ActivityCardBadgeComponentProps, mapStateToProps } from 'component/common/Badge/ActivityCardBadge.selectors';

const ActivityCardBadgeComponent: React.FC<ActivityCardBadgeComponentProps> = (props) => {
    const { badges, activityId, supplierId, screenSize, cms, badgeCategory, isBVariant = false, overrideCategoryProps, locale, currency } = props;
    const badgeContainerElementName = `activity-${badgeCategory}-badges`;
    const badgeService = BadgeService(isBVariant, overrideCategoryProps);
    const { transformBadges, buildSummaryBadges, getBadgeContainerMargin, getBadgeMargin, getContentJustification, getBadgeMaxWidth } = badgeService;

    const [visibleBadges, hiddenBadges] = transformBadges(badges, cms, badgeCategory, screenSize, locale, currency);
    const summaryBadges = buildSummaryBadges(hiddenBadges, badgeCategory, screenSize);
    const allBadges = visibleBadges.concat(summaryBadges);

    if (!allBadges.length) return null;

    const boxMargin = getBadgeContainerMargin(screenSize, badgeCategory);
    const badgeMargin = getBadgeMargin(screenSize, badgeCategory);
    const contentJustification = getContentJustification(badgeCategory);
    const badgeMaxWidth = getBadgeMaxWidth(screenSize, badgeCategory);

    return (
        <Box data-testid={badgeContainerElementName} mt={boxMargin?.mt} display="flex" flexWrap="wrap" width="100%" justifyContent={contentJustification || 'flex-start'}>
            {allBadges.map((b) => (
                <Box key={`box-${b.badge.label}`} maxWidth={badgeMaxWidth}>
                    <BadgeWithTooltip
                        key={b.badge.label}
                        {...b}
                        activityId={activityId}
                        screenSize={screenSize}
                        badgeCategory={badgeCategory}
                        badgeMargin={badgeMargin}
                        badgeType={b.badgeType}
                        supplierId={supplierId}
                    />
                </Box>
            ))}
        </Box>
    );
};

ActivityCardBadgeComponent.displayName = 'ActivityCardBadgeComponent';

const ActivityCardBadge = connect(mapStateToProps)(ActivityCardBadgeComponent);
ActivityCardBadge.displayName = 'ActivityCardBadge';

export default ActivityCardBadge;
